import React, { createContext, useContext, useRef, ReactNode } from 'react';
import { createLimitedActivityStore } from 'lib/store/createLimitedActivityStore';

type StoreType = ReturnType<typeof createLimitedActivityStore>;

const LimitedActivityStoreContext = createContext<StoreType | null>(null);

interface LimitedActivityStoreProviderProps {
  children: ReactNode;
}

export const LimitedActivityStoreProvider = ({ children }: LimitedActivityStoreProviderProps) => {
  const storeRef = useRef<StoreType>();

  if (!storeRef.current) {
    storeRef.current = createLimitedActivityStore();
  }

  return (
    <LimitedActivityStoreContext.Provider value={storeRef.current}>{children}</LimitedActivityStoreContext.Provider>
  );
};

export const useLimitedActivityStoreContext = () => {
  const store = useContext(LimitedActivityStoreContext);
  if (!store) {
    throw new Error('useLimitedActivityStoreContext must be used within LimitedActivityStoreProvider');
  }
  return store;
};
